import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@material-ui/core';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import { faSearch } from '@fortawesome/pro-light-svg-icons';
import { TextField2 } from 'components/UI';
import { FunctionComponent } from 'react';
import { reduceResolution, wbp } from 'Theme';
import clsx from 'clsx';

interface SearchNameProps {
    searchText: string;
    showSearch: boolean;
    onSearchChange: (query: string) => void;
}

// Define estilos personalizados
const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        inputBox: {},
        input: {
            'borderRadius': 30,
            'background': '#FFFFFF !important',
            'marginBottom': '20px',

            '& input': {
                '&::placeholder': {
                    opacity: 1,
                    color: '#7A7A7A'
                },

                [theme.breakpoints.down('sm')]: {
                    height: 47,
                    paddingTop: 0,
                    paddingBottom: 0,
                    fontSize: 14
                }
            },
            '& .MuiInputAdornment-root': {
                'opacity': 0.3,
                'marginRight': 0,
                'pointer-events': 'none',

                '& svg': {
                    cursor: 'default'
                },

                [theme.breakpoints.down('md')]: {
                    'opacity': 1,
                    '& svg': {
                        color: '#000',
                        fontWeight: 400
                    }
                }
            },
            'search': {
                [theme.breakpoints.down(wbp)]: {
                    marginLeft: `${reduceResolution(15)}px`
                },
                [theme.breakpoints.up(wbp)]: {
                    marginLeft: '5px'
                }
            },
            'headerBoton': {},
            'clickable': {
                cursor: 'pointer'
            },
            'iconSearch': {
                [theme.breakpoints.down(wbp)]: {
                    paddingLeft: `${reduceResolution(5)}px`,
                    height: `${reduceResolution(18)}px`
                },
                [theme.breakpoints.up(wbp)]: {
                    paddingLeft: '5px',
                    height: '18px'
                }
            }
        },
        search: {
            [theme.breakpoints.down(wbp)]: {
                marginLeft: `${reduceResolution(15)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                marginLeft: '5px'
            }
        },
        iconSearch: {
            [theme.breakpoints.down(wbp)]: {
                paddingLeft: `${reduceResolution(5)}px`,
                height: `${reduceResolution(18)}px`
            },
            [theme.breakpoints.up(wbp)]: {
                paddingLeft: '5px',
                height: '18px'
            }
        }
    })
);

export const SearchName: FunctionComponent<SearchNameProps> = props => {
    const classes = useStyles();

    const searchIcon = (
        <FontAwesomeIcon
            icon={faSearch}
            className={clsx(!props.showSearch ? classes.iconSearch : classes.search)}
        />
    );

    return (
        <Box className={clsx(classes.inputBox)}>
            <TextField2
                id="pet_tags_search_by_personality_name_input"
                placeholder="Search by Personality Name"
                className={classes.input}
                value={props.searchText}
                onChange={value => props.onSearchChange(value)}
                startIcon={searchIcon}
            />
        </Box>
    );
};

export default SearchName;
